import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import ClientOnboardingWizard from '../../components/admin/client-onboarding/ClientOnboardingWizard';
import ResumeClientCreation, { receiptStorageKey, savedCreation } from '../../components/admin/client-onboarding/ResumeClientCreation';
import { supportsClientCreation } from '../../config/clientOnboardingExecution';

const AdminClientOnboarding: React.FC = () => {
  const { t } = useTranslation(['admin_client_onboarding', 'admin_common']);
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user?.role !== 'superadmin') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Shield className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('admin_common:accessDenied')}</h1>
          <p className="text-gray-600">{t('admin_common:superadminRequired')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="admin-client-onboarding-page">
      {supportsClientCreation() && savedCreation(receiptStorageKey(user))
        ? <ResumeClientCreation key={JSON.stringify([user.id, user.org_id])}
            applyId={savedCreation(receiptStorageKey(user))!} storageKey={receiptStorageKey(user)} />
        : <ClientOnboardingWizard key={JSON.stringify([user.id, user.org_id])}
        isOpen={true}
        onClose={() => navigate('/admin/clients', { replace: true })}
      />}
    </div>
  );
};

export default AdminClientOnboarding;
